/**
 * Statikus fájlok (public → build) útvonala.
 * GitHub Pages almappánál a basename prefix kell (pl. /minimal-car/pictures/...).
 */
export function publicAssetUrl(path) {
    if (!path.startsWith('/'))
        return path;
    const base = typeof process !== 'undefined' ? process.env.PUBLIC_ASSET_PREFIX ?? '' : '';
    const normalized = base.replace(/\/$/, '');
    return normalized ? `${normalized}${path}` : path;
}
